import { render, staticRenderFns } from "./PdfPageSelector.vue?vue&type=template&id=20e9fe02&"
import script from "./PdfPageSelector.vue?vue&type=script&lang=js&"
export * from "./PdfPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e9fe02')) {
      api.createRecord('20e9fe02', component.options)
    } else {
      api.reload('20e9fe02', component.options)
    }
    module.hot.accept("./PdfPageSelector.vue?vue&type=template&id=20e9fe02&", function () {
      api.rerender('20e9fe02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/components/PdfPageSelector.vue"
export default component.exports